// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"dbb5ed27","264":"09f3a153","291":"d43d7d0e","603":"61fc5717","661":"c3039193","924":"d9175d08"}[chunkId] + ".chunk.js";
};